<template>
    <div>
        <table>
            <tr>
                <td>倍率・ヒダスタイル</td>
                <td>
                    <b-form-select v-model="hida_selected"
                                   :options="options"></b-form-select>
                </td>
            </tr>
            <tr v-if="style_selected2_name === ''">
                <td>裏地</td>
                <td>
                    <b-form-select v-model="ura_selected"
                                   :options="$store.state.xlsx_select_data.select_data['カーテン'][$store.state.xlsx_data.style_data[$store.state.step2_data.style_selected1_id].name]['裏地を選ぶ↓ドレープ生地のみ'].option"></b-form-select>
                </td>
            </tr>
            <tr v-if="group2==='フリンジスタイル'">
                <td>フリンジ品番を選ぶ</td>
                <td>
                    <b-form-select v-model="fringe_selected"
                                   :options="$store.state.xlsx_select_data.select_data['カーテン'][style_selected2_name]['フリンジ品番・トリム品番を選ぶ'].option"></b-form-select>
                </td>
            </tr>
            <tr>
                <td>開閉方法</td>
                <td>
                    <b-form-select v-model="open_method_selected"
                                   :options="open_options"></b-form-select>

                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "curtain_drape",
        data : function(){
            return {
            }
        },
        created: function () {
            const style_name = (this.$store.state.step2_data.style_selected2_name !=='') ? this.$store.state.step2_data.style_selected2_name : this.$store.state.step2_data.style_selected1_name
            if(this.hida_selected === ''){
                this.hida_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][style_name]['ヒダ倍率・ヒダスタイルを選ぶ'].option[0].value
            }
            if(this.ura_selected === ''){
                this.ura_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.step2_data.style_selected1_name]['裏地を選ぶ↓ドレープ生地のみ'].option[0].value
            }
            if(this.open_method_selected === ''){
                this.open_method_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][style_name]['開閉方法を選ぶ'].option[0].value
            }

        },
        watch: {
            style_selected1_name : function(value){
                const style_name = (this.$store.state.step2_data.style_selected2_name !=='') ? this.$store.state.step2_data.style_selected2_name : this.$store.state.step2_data.style_selected1_name
                if(this.hida_selected === ''){
                    this.hida_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][style_name]['ヒダ倍率・ヒダスタイルを選ぶ'].option[0].value
                }
                if(this.ura_selected === ''){
                    this.ura_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.step2_data.style_selected1_name]['裏地を選ぶ↓ドレープ生地のみ'].option[0].value
                }
                if(this.open_method_selected === ''){
                    this.open_method_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][style_name]['開閉方法を選ぶ'].option[0].value
                }

            },
            style_selected2_name : function(value){
                if(this.hida_selected === ''){
                    this.hida_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.step2_data.style_selected2_name]['ヒダ倍率・ヒダスタイルを選ぶ'].option[0].value
                }
                if(this.ura_selected === ''){
                    this.ura_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.step2_data.style_selected1_name]['裏地を選ぶ↓ドレープ生地のみ'].option[0].value
                }
                if(this.open_method_selected === ''){
                    this.open_method_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.step2_data.style_selected2_name]['開閉方法を選ぶ'].option[0].value
                }
                if(this.fringe_selected === '' && this.$store.state.step2_data.style_selected2_id && this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2==='フリンジスタイル'){
                    this.fringe_selected = this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.step2_data.style_selected2_name]['フリンジ品番・トリム品番を選ぶ'].option[0].value
                }
            }
        },
        computed: {
            options:{
                get:function(){
                    if(this.$store.state.step2_data.style_selected2_id !==''){
                        //2.5倍ヒダ対策
                        let options = []    //参照渡し対策
                        let option_data = this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].name]['ヒダ倍率・ヒダスタイルを選ぶ'].option
                        for(let index in option_data){
                            if(!option_data[index].value.match(/2.5倍/)) {
                                options.push(option_data[index])
                            }
                        }
                        return options
                    }
                    else if(this.$store.state.step2_data.style_selected1_id !==''){
                        //2.5倍ヒダ対策
                        let options = []    //参照渡し対策
                        let option_data = this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].name]['ヒダ倍率・ヒダスタイルを選ぶ'].option
                        for(let index in option_data){
                            if(!option_data[index].value.match(/2.5倍/)) {
                                options.push(option_data[index])
                            }
                        }
                        return options
                    }else{
                        return false
                    }
                }
            },
            open_options:{
                get:function(){
                    if(this.$store.state.step2_data.style_selected2_id !==''){
                        //2.5倍ヒダ対策
                        let options = []    //参照渡し対策
                        let option_data = this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].name]['開閉方法を選ぶ'].option
                        for(let index in option_data){
                            if(!option_data[index].value.match(/2.5倍/)) {
                                options.push(option_data[index])
                            }
                        }
                        return options
                    }
                    else if(this.$store.state.step2_data.style_selected1_id !==''){
                        //2.5倍ヒダ対策
                        let options = []    //参照渡し対策
                        let option_data = this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].name]['開閉方法を選ぶ'].option
                        for(let index in option_data){
                            if(!option_data[index].value.match(/2.5倍/)) {
                                options.push(option_data[index])
                            }
                        }
                        return options
                    }else{
                        return false
                    }
                }
            },
            hida_selected: {
                get: function () {
                    return this.$store.state.step3_data.hida
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'hida', value:value})
                }
            },
            ura_selected: {
                get: function () {
                    return this.$store.state.step3_data.ura
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'ura', value:value})
                }
            },
            open_method_selected: {
                get: function () {
                    return this.$store.state.step3_data.open
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'open', value:value})
                }
            },
            fringe_selected: {
                get: function () {
                    return this.$store.state.step3_data.fringe
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'fringe', value:value})
                }
            },
            group2: {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2
                    }else {
                        return ''
                    }
                }
            },
            style_selected1_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected1_name
                },
            },
            style_selected2_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected2_name
                },
            }
        },
    }
</script>

<style scoped>

</style>